import React, { Component } from 'react';
import Nav from '../components/nav/Nav';
import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('../components/nav/Footer'), {
    ssr: false,
  });

class PrimaryLayout extends Component<any, {}> {
    render() {
        
        const { children } = this.props;
        return (<>
            <Nav />
            <div className="not-found not-found-is-spaced">
                {children}
            </div>
            <Footer />
        </>)
    }
}

export default PrimaryLayout;
